module.exports = __webpack_public_path__ + "static/media/equity_icon.10407a82.svg";